import type {GroupedHashtagsKeyType} from '../../core/entities/register/constants';
import {useGetHashtagList} from '../../core/repositories/skillRepository';

export const useHashtagData = (
  categoryID: number,
  group: GroupedHashtagsKeyType,
  limit: number,
) => {
  const {data} = useGetHashtagList({
    categoryID,
    group,
    limit,
  });
  return data?.ok
    ? data.value.hashtags.map((tag) => ({
        value: tag.id.toString(),
        label: tag.name,
      }))
    : [];
};
